function gatewayManagement() {
	let gatewayManagement = [
		{
			name: "Gateway Mangement",
			icon: "gateway-management",
			logoName: "MyAccounts",
			// flag: "voucherRequired",
			displayService: "GatewayManagement",
			items: []
		}
	];

	const dashboard = () => {
		const dashboardArr = [
			{
				path: "/index/Gateway-Management",
				name: "Dashboard",
				icon: "dashboard",
				logoName: "dashboard",
				flag: "DASHBOARD"
			},
		];

		return dashboardArr;
	};

	const gatewayManagementSub = () => {
		const profileArr = [
			{
				path: "/index/gatewayManagement",
				name: "Gateway Management",
				icon: "gatewayManagement",
				logoName: "MyBank",
				flag: "GATEWAY MANAGEMENT",
			}
		];

		// if (
		//   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
		// ) {
		return profileArr;
		// } else {
		//   return "";
		// }
	};

	const MemberMapping = () => {
		const memMapping = [
			{
				path: "/index/memberMapping",
				name: "Member Mapping",
				icon: "memberMapping",
				logoName: "management",
				flag: "MEMBER MAPPING",
			}
		];

		return memMapping;
	}

	let a = dashboard();
	let b = gatewayManagementSub();
	let c = MemberMapping();

	gatewayManagement[0].items = [...a, ...b, ...c];

	return gatewayManagement;
}

export default gatewayManagement;
